/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: Overlay.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  07.02.23 10:08 am.
 * Last modified: 07.02.23 10:08 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { useSettings } from '../contexts/SettingsContext';

const Overlay = () => {
    const [{ openType }] = useSettings();

    return <div className={`egt_lobby_overlay egt_lobby_overlay_${openType}`}></div>;
};

export default Overlay;
